import React, { useState } from 'react';
import Logo from './Logo';
import { api } from '../api/client';

export default function DeviceActivation({ onActivated }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setError('');
    setSubmitting(true);
    try {
      await api.activateDevice(code.trim());
      onActivated();
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="kiosk">
      <div className="kiosk-header">
        <div className="logo-frame"><Logo size={44} /></div>
      </div>

      <div className="contacts-form-wrap" style={{ maxWidth: 420, textAlign: 'center' }}>
        <h2 style={{ marginBottom: 6 }}>Dispositivo non attivato</h2>
        <p className="modal-subtitle">
          Questo dispositivo deve essere attivato una sola volta prima di poter essere usato.
          Chiedi il codice di attivazione all'amministratore e inseriscilo qui sotto.
        </p>

        {error && <div className="form-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="field">
            <input
              type="text"
              className="big-badge-input"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="Codice di attivazione"
              maxLength={12}
              autoComplete="off"
              autoFocus
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={submitting || !code.trim()}>
            {submitting ? 'Attivazione…' : 'Attiva dispositivo'}
          </button>
        </form>
      </div>
    </div>
  );
}
